import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedCSSPropertyName } from '@app/eds/constants';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  // cardPadding provides padding value
  @Input() padding!: string;

  // whether to apply hovering effect/not
  @Input() isHoverable = false;

  // onClick event to trigger the parent component's method
  @Output() cardClick = new EventEmitter();

  /**
   * This method is used to emit the event to the parent.
   */
  cardOnClick = (): void => this.cardClick.emit();

  /**
   * This method will return custom styles
   *
   * @returns {object} styleObject
   */
  getStyles = () => {
    const styleObject: { [key: string]: string } = {};

    this.padding && (styleObject[SharedCSSPropertyName.PADDING] = this.padding);

    return styleObject;
  };

  /**
   * This method return the classname
   *
   * @returns {string} classname
   */
  getClassName = (): string => (this.isHoverable ? 'hoverable-card' : '');
}
